export default {
  allProducts: [],
  cart: [],
  searchs: [],
  onSale: [],
  products: [],
  shoes: [],
  bags: [],
  tshirt: [],
  belts: [],
  Jeans: [],
  kids: [],
  general: [],
  relatedproducts: [],
  firstname: "",
  lastname: "",
  email: "",
  amount: 0,
  checkout: false,
  isloading: false,
  loading: true,
  componentIsLoading: true,
  componentIsSearching: false,
  checkoutInfo: false,
  paystackPayment: false,
  showSearch: false,
  searchName: null,
  states: [
    "Abia",
    "Adamawa",
    "Akwa-ibom",
    "Anambra",
    "Bauchi",
    "Bayelsa",
    "Benue",
    "Borno",
    "Cross River",
    "Delta",
    "Enugu",
    "Imo",
    "Jigawa",
    "Kaduna",
    "Katsina",
    "Kano",
    "Kebbi",
    "Kolgi",
    "Lagos",
    "Nasarawa",
    "Niger",
    "Ogun",
    "Ondo",
    "Osun",
    "Oyo",
    "Plateu",
    "Rivers",
    "Sokoto",
    "Taraba",
    "Zamfara",
  ],
};
